<template>
    <div>
        <form
            v-if="!currentUser.isGoogleCalendarSyncEnabled"
            class="tw-mb-5"
            @submit.prevent="onGoogleCalendarSync"
        >
            <l-base-button type="submit" :button-types="['default', 'raised']">
                {{ $t("profile.enableGoogleCalendarIntegration") }}
            </l-base-button>
        </form>
        <form v-else class="tw-mb-5" @submit.prevent="onGoogleCalendarDesync">
            <l-base-button type="submit" :button-types="['default', 'raised']">
                {{ $t("profile.disableGoogleCalendarIntegration") }}
            </l-base-button>
        </form>

        <form data-test-id="user-calendar-form" @submit.prevent="onCalendarSyncLinkGenerate">
            <div class="tw-mb-4 tw-text-gray-400" v-html="$t('profile.edit.calendarLabel')"></div>
            <l-base-button v-show="!syncUri" type="submit" :button-types="['default', 'raised']">
                {{ $t("profile.edit.btnCreate") }}
            </l-base-button>
            <div v-show="syncUri">
                <div class="tw-text-xs tw-leading-tight tw-mb-4">
                    {{ $t("profile.edit.calendarCopied") }}
                </div>
                <label class="tw-hidden" for="syncUri"></label>
                <input
                    id="syncUri"
                    ref="syncUri"
                    type="text"
                    :class="{ 'tw-hidden': hideClipboardInput }"
                    :value="syncUri"
                />
                <pre class="tw-text-xxs tw-leading-none" data-test-id="calendar-sync-link">{{
                    syncUri
                }}</pre>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api";

import LBaseButton from "@/components/LBaseButton";

export default {
    components: {
        LBaseButton,
    },
    data() {
        return {
            syncUri: "",
            hideClipboardInput: false,
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
        }),
    },
    created() {
        if (this.$route.query.refreshToken) {
            this.$store.dispatch("auth/performSessionRefresh");
        }
    },
    methods: {
        async onCalendarSyncLinkGenerate() {
            const { data } = await api.post("/api/calendar/create");

            this.syncUri = `${window.location.origin}/api/calendar/subscribe/${data.calendar?.uri}`;

            this.$nextTick(() => {
                if (this.$refs.syncUri) {
                    this.$refs.syncUri.select();
                    document.execCommand("copy");
                    this.hideClipboardInput = true;
                }
            });
        },
        async onGoogleCalendarSync() {
            const { data } = await api.get(
                `/api/google-calendar/auth/init?redirect=${encodeURIComponent(
                    `/app/#${this.$route.path}?refreshToken=1`,
                )}`,
            );

            window.location.href = data.url;
        },
        async onGoogleCalendarDesync() {
            await api.post("/api/google-calendar/unsubscribe", {
                isGoogleCalendarSyncEnabled: false,
            });

            this.$store.dispatch("auth/performSessionRefresh");
        },
    },
};
</script>
